import axiosInstance from '../../axiosInstance';

/**
 * Interface for device script execution response
 */
export interface DeviceScriptResponse {
  status: {
    [key: string]: {
      status?: boolean | string;
      severity?: string;
      [key: string]: any;
    };
  };
  system: {
    ram: string;
    flash: string;
    sim_provider: {
      value: string;
      color: string;
    };
    modem: string;
    version: {
      im: string;
      sw: string;
    };
  };
  measurements: {
    [key: string]: {
      value: number;
      valid: boolean;
      severity: string;
    };
  };
  box_id: string;
}

/**
 * Run the macIO read script for the specified device numbers
 * @param deviceNumbers Array of device box numbers
 * @returns Promise with the script execution response
 */
export const runMacioReadScript = async (deviceNumbers: string[]): Promise<DeviceScriptResponse[]> => {
  try {
    // Join device numbers with spaces for the query parameter
    const deviceNumbersParam = deviceNumbers.join(' ');
    
    // Call the API endpoint
    const response = await axiosInstance.get<DeviceScriptResponse[]>(
      `/serwis/run-macio-read-boxes?device_numbers=${deviceNumbersParam}`
    );
    
    return response.data;
  } catch (error) {
    console.error('Error running macIO read script:', error);
    throw error;
  }
};

/**
 * Service for device script operations
 */
const scriptService = {
  runMacioReadScript,
};

export default scriptService;
